import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import "./Gallery.css";

// Gallery image paths from assets directory
const imageUrls = [
  "./assets/img1.png",
  "/assets/img2.png",
  "/assets/img3.png",
  "/assets/img4.png",
  "/assets/img5.png",
  "/assets/img6.png",
  "/assets/img7.png",
  "/assets/img8.png",
  "/assets/img9.png",
  "/assets/img10.png",
  "/assets/img11.png",
  "/assets/img12.png",
];

// Randomly shuffle array elements for varied display
function shuffleArray(array: string[]) {
  return array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

export function Gallery() {
  const [shuffledImages, setShuffledImages] = useState<string[]>([]);

  // Shuffle images on component mount
  useEffect(() => {
    setShuffledImages(shuffleArray(imageUrls));
  }, []);

  return (
    <div className="bg-gradient-to-br from-yellow-50 via-orange-100 to-pink-50 min-h-screen py-16 px-6">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl bg-gradient-to-r from-orange-600 to-yellow-500 bg-clip-text text-transparent">Photo Gallery</h1>
        <p className="mt-4 text-xl text-gray-600 font-light mb-10">Sacred glimpses of the temple and divine deities</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {shuffledImages.map((url, index) => (
            <div key={index} className="overflow-hidden rounded-lg shadow-lg fade-in">
              <img
                src={url}
                alt={`Sacred ${index}`}
                className="w-full h-64 object-cover transform hover:scale-105 transition duration-500 ease-in-out rounded-lg"
              />
            </div>
          ))}
        </div>

        <div className="mt-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-4 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700 transition"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}